import { Button } from 'antd'
import { DeleteOutlined, StarFilled, StarOutlined } from '@ant-design/icons'

const GOLDEN_COLOR = '#fa541c'

type Props = {
  isMarked: boolean
  pending: boolean
  onAdd: () => void
  onRemove: () => void
}

const GoldenPromptControl = ({ isMarked, pending, onAdd, onRemove }: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 4,
        marginTop: 4,
      }}
    >
      {isMarked ? (
        <>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: GOLDEN_COLOR }}>
            <StarFilled style={{ color: GOLDEN_COLOR }} />
            <span style={{ fontSize: 12 }}>Golden Data Set</span>
          </span>
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            loading={pending}
            onClick={onRemove}
          >
            Remove From Golden Data Set
          </Button>
        </>
      ) : (
        <>
          <StarOutlined style={{ color: '#bfbfbf' }} />
          <Button
            size="small"
            icon={<StarOutlined />}
            loading={pending}
            onClick={onAdd}
          >
            Add to Golden Data Set
          </Button>
        </>
      )}
    </div>
  )
}

export default GoldenPromptControl
